import React, { useContext } from 'react';
import { useSelector } from 'react-redux';

import { getSurvey } from '../../survey/survey.selectors';

export const SurveyContext = React.createContext('');

export const useContextualSurvey = () => useSelector(getSurvey(useContext(SurveyContext)));
